import { styled } from '@linaria/react'
import React, { forwardRef } from 'react'
import { colors } from '../styles/colors'
import { Input } from '../ui/Input'
import CloseIcon from '../svgr/Close'
import { ErrorText } from '../ui/ErrorText'

export const OptionInput = forwardRef<
  HTMLInputElement,
  {
    value: string
    onChange: (value: string) => void
    onRemove?: () => void
    placeholder?: string
    showRemove?: boolean
    hasError?: boolean
    errorMessage?: string
  }
>(
  (
    {
      value,
      onChange,
      onRemove,
      placeholder,
      showRemove,
      hasError,
      errorMessage,
    },
    ref,
  ) => {
    return (
      <Container>
        <InputWrapper hasError={hasError}>
          <Input
            ref={ref}
            value={value}
            onChange={e => onChange(e.target.value)}
            placeholder={placeholder}
          />

          {showRemove && onRemove && (
            <RemoveButton type="button" onClick={onRemove}>
              <CloseIcon />
            </RemoveButton>
          )}
        </InputWrapper>

        {hasError && errorMessage && <ErrorText>{errorMessage}</ErrorText>}
      </Container>
    )
  },
)

OptionInput.displayName = 'OptionInput'

const Container = styled.div`
  display: grid;
  gap: 4px;
`

const InputWrapper = styled.div<{ hasError?: boolean }>`
  position: relative;
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
`

const RemoveButton = styled.button`
  cursor: pointer;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: background-color 0.2s ease;

  &:hover {
    background: ${colors.bgTertiary};
  }

  &:active {
    transform: scale(0.95);
  }
`
